import React, { useEffect, useState } from "react";
import { Space, Spin } from "antd";
import StepHeader from "../../Evaluation/StepHeader";
import { Config } from "../../../model_gen/config";
import { IntentService } from "../../../services/IntentService";
import { usePermissions } from "../../../PermissionsProvider";
import ConfigurationPanel from "../../Application/configuration/ConfigurationPanel";
import { IntentGroup } from "../../../model_gen/evaluation";

interface TestRunConfigProps {
  intentGroupId: number;
  testSetId: number;
  config?: Config;
  onChange: (config: Config) => void;
}

const TestRunConfig: React.FC<TestRunConfigProps> = ({
  intentGroupId,
  config: initialConfig,
  onChange,
}) => {
  const { apiKey } = usePermissions();
  const [isLoading, setIsLoading] = useState(true);
  const [config, setConfig] = useState<Config | undefined>(initialConfig);

  useEffect(() => {
    // Fetch initial config if not provided
    if (!initialConfig) {
      IntentService.getIntentGroup(
        intentGroupId,
        false,
        setIsLoading,
        apiKey,
      ).subscribe(
        (fetchedIntentGroup: IntentGroup) => {
          setConfig(fetchedIntentGroup.config);
          onChange(fetchedIntentGroup.config);
        },
        (error: any) => {
          console.error(error);
          setIsLoading(false);
        },
      );
    } else {
      setIsLoading(false);
    }
  }, [intentGroupId]);

  const updateConfig = (newConfig: Partial<Config>, loadingHandler: any) => {
    setConfig((prevConfig) => {
      if (!prevConfig) return newConfig;
      const updatedConfig = { ...prevConfig, ...newConfig };
      onChange(updatedConfig);
      loadingHandler(false);
      return updatedConfig;
    });
  };

  if (isLoading) {
    return <Spin />;
  }

  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      <StepHeader
        title="Test Run Configuration"
        description="Configure the settings for this test run"
      />

      <ConfigurationPanel
        intentGroupId={intentGroupId ? Number(intentGroupId) : null}
        config={config}
        updateConfig={updateConfig}
        resetConfig={() => {}}
        isModalOpen={false}
        allowSecondaryModel={false}
        showSystemPrompt={true}
      />
    </Space>
  );
};

export default TestRunConfig;
